import { SchemaContext } from "context-for/schema/schema.context";
import { useContext } from "react";

export const useSchemaContext = () => {
    const context = useContext(SchemaContext);
    if (!context) {
        throw new Error("useSchemaContext must be used within a SchemaProvider");
    }
    return context;
};
